export enum AppDataRules {
  DamageLineApproval = 'DamageLineApproval',
  RetailCost = 'RetailCost',
  TnrStatusNotification = 'TnrStatusNotification',
  RejectInspectionNotification = 'RejectInspectionNotification',
  RequireReviewInspectionNotification = 'RequireReviewInspectionNotification',
  HideInspectionsBeforeDate = 'HideInspectionsBeforeDate',
}

export enum AppDataRuleParams {
  ResponsibilityShortcutCode = 'ResponsibilityShortcutCode',
  ResponsibilityCode = 'ResponsibilityCode',
  NovuTopicKey = 'NovuTopicKey',
  CutoffDateTimeInternal = 'CutoffDateTimeInternal',
  CutoffDateTimeCustomer = 'CutoffDateTimeCustomer',
  CutoffDateTimeSubCustomer = 'CutoffDateTimeSubCustomer',
}
